import { DOCUMENT_PATTERNS, FALLBACK_PATTERN } from './safeRegexPatterns';

/**
 * Normalizes a given string based on a safe, pre-validated regular expression.
 * Uses a whitelist of safe patterns to prevent ReDoS attacks.
 *
 * @param {string} regex - The regular expression pattern string to match against whitelist.
 * @param {string} string - The input string to be normalized.
 * @returns {string} - A string with matches of the safe regular expression removed.
 */
const normalizeRegex = (regex, string) => {
  if (typeof string !== 'string') {
    console.error('Invalid input: string must be a string');
    return '';
  }

  if (!regex) {
    return string.replace(FALLBACK_PATTERN, '');
  }

  const safePattern = DOCUMENT_PATTERNS[regex];
  if (safePattern) {
    return string.replace(safePattern, '');
  }

  console.warn(`Unknown regex pattern rejected for security: ${regex}. Using fallback pattern.`);
  return string.replace(FALLBACK_PATTERN, '');
};

export default normalizeRegex;
